import "@styles/sharedtheme.scss"

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { configure as configureDXLicense } from "@services/devextreme/license-helper"
import Toast, { type PluginOptions } from "vue-toastification"
import { setupApi } from "@services/http/api-service"
import { configureI18n } from "@services/i18n/i18nservice"
import App from './App.vue'
import { configureRouter, useRouter } from "@services/routing-services"
import { configureAppRoutes } from "./router"
import { configureAuthorization } from "./.shared/services/auth/authorization"
import { autoApplyLayoutToRoutesWithAuth } from "./.shared/services/layout"
import PublicLayout from "./components/layouts/PublicLayout.vue"
import NotFoundView from "./.shared/views/NotFoundView.vue"
import { rand } from "@vueuse/core"
import { loadMessages, locale } from "devextreme/localization"
import { useIntl } from '@/.shared/services/i18n';
import moment from 'moment';
import "leaflet/dist/leaflet.css";
import "leaflet/dist/images/marker-icon.png";
import { initializeLinq } from "linq-to-typescript"
configureDXLicense();
initializeLinq();
moment.locale('es');


if (import.meta.env.VITE_IS_DEBUG === "true") {
    (window as any)["instance_id"] = rand(0, 99999);
}

const app = createApp(App);

await configureI18n({
    app: app,
    defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE,
    fallbackLocales: import.meta.env.VITE_FALLBACK_LOCALES === "" ? undefined : JSON.parse(import.meta.env.VITE_FALLBACK_LOCALES),
    supportedLocales: import.meta.env.VITE_SUPPORTED_LOCALES === "" ? undefined : JSON.parse(import.meta.env.VITE_SUPPORTED_LOCALES),
    localeSelectorFallbackMode: "LanguageIgnoreRegion",
    logWarns: import.meta.env.VITE_SUPPRESS_I18N_WARNINGS !== "true",
    onLocaleChanged: async (l) => {
        const lang = l.split("-")[0];
        try {
            const messages = await import(`@/../../node_modules/devextreme/localization/messages/${lang}.json`);
            loadMessages(messages.default);
            locale(l);
        }
        catch (e) {
            console.warn(`No se puedo cargar localización de DevExtreme para el idioma ${lang}`);
        }
    }
});


setupApi();

configureRouter(router => { router.addRoute("not-found", b => b.isRoot().withPath("/:pathMatch(.*)*").allowAnonymous().withComponent(NotFoundView)) });
configureAppRoutes();
autoApplyLayoutToRoutesWithAuth(PublicLayout, null);

app.use(createPinia())
app.use(Toast, {} as PluginOptions);
const router = useRouter();
app.use(router)
app.mount('#app')